import esMessages from "../locales/es_ES.json";
import { LangConfig } from "../model";

export const EsLang: LangConfig = {
  messages: {
    ...esMessages,
  },
  locale: "es-ES",
};
